import React from "react";

import HeaderCell from "./headerCell";
import CustomCheckbox from "../customCheckbox";
import styled from "styled-components";
import { useSelector } from "services/redux/rootReducer";
import { TableDefinition } from "features/shared/types/table";

interface Props {
    onSelectAllCallback: () => void;
    onColumnClickHandler: (accessor: string) => void;
}

const HeaderRow: React.FC<Props> = ({
    onSelectAllCallback,
    onColumnClickHandler,
}) => {
    const { tableDefinition, selectAllChecked } = useSelector(
        (state) => state.table
    );

    return (
        <StyledHeaderRow rowTemplate={tableDefinition.rowTemplate}>
            <HeaderCell onColumnClickHandler={onSelectAllCallback}>
                <CustomCheckbox
                    onClickHandler={onSelectAllCallback}
                    isChecked={selectAllChecked}
                />
            </HeaderCell>
            {tableDefinition.rowTemplate
                .filter((cellTemplate) => cellTemplate.isShown)
                .map((cellTemplate) => {
                    return (
                        <HeaderCell
                            key={cellTemplate.accessor}
                            cellTemplate={cellTemplate}
                            onColumnClickHandler={() =>
                                onColumnClickHandler(cellTemplate.accessor)
                            }
                        >
                            {cellTemplate.header.toUpperCase()}
                        </HeaderCell>
                    );
                })}
        </StyledHeaderRow>
    );
};

const StyledHeaderRow = styled.tr<{
    rowTemplate: TableDefinition["rowTemplate"];
}>`
    width: 100%;
    display: grid;
    grid-template-columns: ${(props) => {
        const checkboxTemplate = `2.5rem`;
        const generatedTemplate = props.rowTemplate
            .filter((cellTemplate) => cellTemplate.isShown)
            .map(({ flex, columnWidth, minCellWidth }) =>
                columnWidth || minCellWidth
                    ? `${columnWidth ?? minCellWidth ?? 0}px`
                    : `minmax(${(minCellWidth ?? 100) / 16}rem, ${flex || 1}fr)`
            )
            .join(" ");
        return `${checkboxTemplate} ${generatedTemplate}`;
    }};
`;

export default HeaderRow;
